import React, { useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ExpressSection.css";
// import banner from "../../assets/images/fewwwwwd 2.png";
import banner from "../../assets/images/map2.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ExpressSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);

  return (
    <>
      <Row className="d-flex justify-content-center align-items-center py-5">
        <Col xs={12} md={8} lg={6} data-aos="fade-up">
          <Card className="text-center shadow-lg border-0 p-4 rounded-4 express-card">
            <Card.Body className="express-card-body">
              <h4 className="fw-bold mb-3">
                {t("expressSection.offer")}     
                
                </h4>
                <p className="express-text my-3">kostenlos & unverbindlich</p>
              <Button
                className="btn-orange btn-xl fw-bold shadow"
                onClick={() => navigate("/transport")}
              >
                {t("expressSection.button")}              
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <section className="express-sectionn py-5">
        <Container>
          <Row className="align-items-center justify-content-between">
            {/* Text */}
            <Col xs={12} md={7} lg={7} data-aos="fade-right">
              <h2 className="express-title">
                {t("expressSection.title")}{" "}
                <span className="text-orange">
                  {t("expressSection.titleHighlight")}
                </span>
              </h2>
              <p className="express-text mt-4">
                {t("expressSection.description1")}
              </p>
              <p>{t("expressSection.description2")}</p>
              <p>{t("expressSection.description3")}</p>
            </Col>

            {/* Image */}
            <Col xs={12} md={5} lg={5} data-aos="zoom-in">
              <div className="image-container">
                <img
                  src={banner}
                  alt={t("expressSection.imageAlt")}
                  className="express-imagee img-fluid"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
